export default function normalizeUrl(url) {
	return url
		.toLowerCase()
		.normalize('NFD')
		.replace(/([\u0300-\u036f]|[^0-9a-zA-Z_-])/g, '');
}
